<template>
  <div class="machine-type-tree-manage-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('machineTypeTree.page.title')" :subtitle="$t('machineTypeTree.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-plus" @click="openAddParentMachineTypeModal">
          {{ $t('machineTypeTree.addParent') }}
        </el-button>
        <el-button size="small" icon="el-icon-plus" :disabled="!currentTypeId" @click="openAddMachineTypeModal">
          {{ $t('machineTypeTree.addChild') }}
        </el-button>
        <el-button size="small" icon="el-icon-edit" :disabled="!currentTypeId" @click="openEditMachineTypeModel">
          {{ $t('machineTypeTree.edit') }}
        </el-button>
        <el-button size="small" type="danger" icon="el-icon-delete" :disabled="!currentTypeId" @click="openDeleteMachineTypeModel">
          {{ $t('machineTypeTree.delete') }}
        </el-button>
      </template>
    </ds-page-header>

    <el-row :gutter="16">
      <el-col :xs="24" :sm="6" :md="5" :lg="4">
        <div class="ds-panel ds-panel--padded">
          <div class="ds-panel__header">
            <span class="ds-panel__title">{{ $t('machineTypeTree.page.treeTitle') }}</span>
          </div>
          <machine-type-tree ref="machineTypeTree" @switchType="handleSwitchType" />
        </div>
      </el-col>
      <el-col :xs="24" :sm="18" :md="19" :lg="20">
        <!-- (2) 详情面板 -->
        <div class="ds-panel ds-panel--padded">
          <div class="ds-panel__header">
            <span class="ds-panel__title">{{ $t('machineTypeTree.detail') }}</span>
            <ds-status-tag
              v-if="machineTypeInfo.isEnable"
              size="sm"
              :type="machineTypeInfo.isEnable === '1000' ? 'success' : 'muted'"
              :label="machineTypeInfo.isEnable === '1000' ? $t('machineTypeTree.enable') : $t('machineTypeTree.disable')" />
          </div>
          <div class="ds-info-grid">
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('machineTypeTree.machineTypeName') }}</span>
              <span class="ds-info-grid__value">{{ machineTypeInfo.machineTypeName || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('machineTypeTree.machineTypeCode') }}</span>
              <span class="ds-info-grid__value ds-num">{{ machineTypeInfo.machineTypeCode || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('machineTypeTree.status') }}</span>
              <span class="ds-info-grid__value">{{ machineTypeInfo.isEnable === '1000' ? $t('machineTypeTree.enable') : $t('machineTypeTree.disable') }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('machineTypeTree.importanceLevel') }}</span>
              <span class="ds-info-grid__value">
                <template v-for="(item, index) in importanceLevels">
                  <span v-if="machineTypeInfo.importanceLevel == item.statusCd" :key="index">{{ item.name }}</span>
                </template>
                <span v-if="!machineTypeInfo.importanceLevel">-</span>
              </span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('machineTypeTree.seq') }}</span>
              <span class="ds-info-grid__value ds-num">{{ machineTypeInfo.seq || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('machineTypeTree.unit') }}</span>
              <span class="ds-info-grid__value">{{ machineTypeInfo.unit || '-' }}</span>
            </div>
            <div class="ds-info-grid__item">
              <span class="ds-info-grid__label">{{ $t('machineTypeTree.warrantyDeadline') }}</span>
              <span class="ds-info-grid__value ds-num">{{ machineTypeInfo.warrantyDeadline || '-' }}</span>
            </div>
            <div class="ds-info-grid__item ds-info-grid__item--wide">
              <span class="ds-info-grid__label">{{ $t('machineTypeTree.remark') }}</span>
              <span class="ds-info-grid__value">{{ machineTypeInfo.remark || '-' }}</span>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <add-machine-type ref="addMachineType" @success="handleSuccess" />
    <edit-machine-type ref="editMachineType" @success="handleSuccess" />
    <delete-machine-type ref="deleteMachineType" @success="handleSuccess" />
  </div>
</template>

<script>
import { getDict } from '@/api/community/communityApi'
import { getCommunityId } from '@/api/community/communityApi'
import MachineTypeTree from '@/components/machine/machineTypeTree'
import AddMachineType from '@/components/machine/addMachineType'
import EditMachineType from '@/components/machine/editMachineType'
import DeleteMachineType from '@/components/machine/deleteMachineType'
import { listMachineType } from '@/api/machine/machineTypeTreeManageApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'MachineTypeTreeManageList',
  components: {
    MachineTypeTree,
    AddMachineType,
    EditMachineType,
    DeleteMachineType,
    DsPageHeader,
    DsStatusTag
  },
  data() {
    return {
      machineTypeInfo: {},
      importanceLevels: [],
      currentTypeId: '',
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const data = await getDict('machine_type', 'importance_level')
        this.importanceLevels = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleSwitchType(data) {
      this.currentTypeId = data.typeId
      this.machineTypeInfo = {
        ...data
      }
      this._loadMachienType()
    },
    openAddParentMachineTypeModal() {
      this.$refs.addMachineType.open({})
    },
    openAddMachineTypeModal() {
      if (!this.currentTypeId) {
        this.$message.warning(this.$t('machineTypeTree.selectTypeFirst'))
        return
      }
      this.$refs.addMachineType.open({ typeId: this.currentTypeId })
    },
    openEditMachineTypeModel() {
      if (!this.currentTypeId) {
        this.$message.warning(this.$t('machineTypeTree.selectTypeFirst'))
        return
      }
      this.$refs.editMachineType.open(this.machineTypeInfo)
    },
    openDeleteMachineTypeModel() {
      if (!this.currentTypeId) {
        this.$message.warning(this.$t('machineTypeTree.selectTypeFirst'))
        return
      }
      this.$refs.deleteMachineType.open(this.machineTypeInfo)
    },
    async _loadMachienType() {
      const res = await listMachineType({ communityId: getCommunityId(), typeId: this.machineTypeInfo.typeId, page: 1, row: 1 });
      this.machineTypeInfo = { ...res.data[0] }
    },
    handleSuccess() {
      this.$refs.machineTypeTree.refreshTree()
      this.handleSwitchType(this.machineTypeInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
.machine-type-tree-manage-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);

  &__item {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &--wide {
      grid-column: 1 / -1;
    }
  }

  &__label {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
  }

  &__value {
    font-size: var(--ds-font-size-md);
    color: var(--ds-gray-800);
    word-break: break-all;
  }
}
</style>
